/* eslint-disable */
import React, { useRef } from 'react'
import * as THREE from 'three'

import 'react-three-fiber'

function BaseLine({ side = 'l', dist = 300, position = [0, 0, 3] }) {
    const mesh = useRef()

    const isLeft = side === 'l'
    const width = 1
    const halfWidth = 0.5 * width
    const halfLength = 0.5 * dist
    const theta = isLeft ? 0.25 * Math.PI : -0.25 * Math.PI
    const translate = {
        x: isLeft ? width : -halfWidth,
        y: 0,
        z: -halfLength - 4,
    }
    const geometry = new THREE.BoxGeometry(width, 0.01, dist)
    const material = new THREE.MeshPhongMaterial({ color: 0xf5f5f5 })

    geometry.translate(translate.x, translate.y, translate.z)

    return (
        <mesh
            ref={mesh}
            name={isLeft ? 'left_baseline' : 'right_baseline'}
            rotation={[0.5 * Math.PI, theta, 0]}
            translate={translate}
            position={[position[0], 0, 2.5]}
            geometry={geometry}
            material={material}
        />
    )
}

export default BaseLine
